// extracted by mini-css-extract-plugin
module.exports = {"faqWrapper":"_3wNivP","faqList":"_12TqOX","faqTitle":"_3wA81X","faqItem":"_2fN5hf","faqItemTitle":"cgN73W"};